/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql, Link } from "gatsby"

import Header from "./header"
import "./layout.css"

import * as style from "./css/footer.module.css"

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
      <Header siteTitle={data.site.siteMetadata.title} />

      <div id="content">{children}</div>

      <footer className={`${style.footer} footer`}>
        <div className={`${style.footerFrame} footer-frame`}>
          <dl className={`${style.footerNavigation} footer-navigation`} itemScope itemType="http://www.schema.org/SiteNavigationElement">
            <dt className={`${style.companyName} company-name`}>柏魚市場株式会社</dt>
            <dd className={`${style.navItem} nav-item`} itemProp="name"><Link to={`/`} className={`${style.navLabel} nav-label`} itemProp="url">トップ</Link></dd>
            <dd className={`${style.navItem} nav-item`} itemProp="name"><Link to={`/article/greetings/`} className={`${style.navLabel} nav-label`} itemProp="url">ごあいさつ</Link></dd>
            <dd className={`${style.navItem} nav-item`} itemProp="name"><Link to={`/about-us/#overview`} className={`${style.navLabel} nav-label`} itemProp="url">会社概要</Link></dd>
            <dd className={`${style.navItem} nav-item`} itemProp="name"><Link to={`/company-history`} className={`${style.navLabel} nav-label`} itemProp="url">社史</Link></dd>
            <dd className={`${style.navItem} nav-item`} itemProp="name"><Link to={`/market`} className={`${style.navLabel} nav-label`} itemProp="url">交通アクセス</Link></dd>
            <dd className={`${style.navItem} nav-item`} itemProp="name"><Link to={`/article/recruit/`} className={`${style.navLabel} nav-label`} itemProp="url">求人情報</Link></dd>
            <dd className={`${style.navItem} nav-item`} itemProp="name"><Link to={`/about-us/#department`} className={`${style.navLabel} nav-label`} itemProp="url">部門紹介</Link></dd>
            <dd className={`${style.navItem} nav-item`} itemProp="name"><Link to={`/about-us/#associated-company`} className={`${style.navLabel} nav-label`} itemProp="url">関連会社</Link></dd>
          </dl>
          <p className={`${style.address} address`}>
            〒277-8545　千葉県柏市若柴69-1<a href="https://goo.gl/maps/YPvsAoQoT6EhwZxy9" className={`${style.mapLabel} map-label`}>MAP</a>
          </p>
          <p className={`${style.copyright} copyright`}>
            著作権は柏魚市場株式会社に属します。掲載の文章・写真・図版などの無断転載を禁止します。<br />
            Copyright © 2000 - {new Date().getFullYear()} KASHIWA UOICHIBA Co., Ltd. All Rights Reserved.
          </p>
        </div>
      </footer>

    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
